import { render, staticRenderFns } from "./SortOrderToggle.vue?vue&type=template&id=512b1aef&scoped=true&"
import script from "./SortOrderToggle.vue?vue&type=script&lang=js&"
export * from "./SortOrderToggle.vue?vue&type=script&lang=js&"
import style0 from "./SortOrderToggle.vue?vue&type=style&index=0&id=512b1aef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b1aef",
  null
  
)

export default component.exports